import { matchPath, useLocation } from 'react-router-dom'

import { useNavigation as useFactorialNavigation } from 'modules/core/hooks/useNavigation'

const useIsContractFlows = (): boolean => {
  const { pathname } = useLocation()
  const { navigation } = useFactorialNavigation()

  const getContractFlowPatterns = (): string[] => [
    navigation.employees.id.contractVersions.fix.fullPath({
      id: ':id',
      contractVersionId: ':contractVersionId',
    }),
    navigation.employees.id.contractVersions.update.fullPath({
      id: ':id',
    }),
    navigation.employees.id.contractVersions.promotion.fullPath({
      id: ':id',
    }),
  ]
  const contractFlowPaths = getContractFlowPatterns().find((pattern) =>
    matchPath(pattern, pathname)
  )
  return !!contractFlowPaths
}

export default useIsContractFlows
